import React, { useEffect, useRef, useState, useImperativeHandle } from "react";
import { Modal, Panel, Text } from "rsuite";
import { notification, Button } from "antd";
import { FaBackward } from "react-icons/fa";

export const ModalConsentimientos = ({ idNegocio, idPaciente, ref }) => {
  const [isOpen, setIsOpen] = useState(false);
  const initialized = useRef(false);
  const [api, contextHolder] = notification.useNotification();
	

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
    }
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((_) => !_),
    }),
    [],
  );

  return (
    <div>
      {contextHolder}
      <Modal
        backdrop={"static"}
        keyboard={true}
        size={"lg"}
        open={isOpen}
        onClose={handleClose}
      >
        <Modal.Header>
          <Modal.Title>
            Lista de Consentimientos
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered header="Consentimientos firmados">
            
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleClose}
            type="default"
            icon={<FaBackward></FaBackward>}
          >
            Regresar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
